import { KaizenLabServiceRepository } from '../../domain/repository/KaizenLabServiceRepository';
import { KaizenLabServiceStore } from '../../domain/store/KaizenLabServiceStore';
import UiState from '../../domain/store/UiState';

export class KaizenLabServiceUsecase {
  private kaizenLabServiceRepository: KaizenLabServiceRepository;
  private kaizenLabServiceStore: KaizenLabServiceStore;
  private uiState: UiState;

  constructor({
    kaizenLabServiceRepository,
    kaizenLabServiceStore,
    uiState,
  }: {
    kaizenLabServiceRepository: KaizenLabServiceRepository;
    kaizenLabServiceStore: KaizenLabServiceStore;
    uiState: UiState;
  }) {
    this.kaizenLabServiceRepository = kaizenLabServiceRepository;
    this.kaizenLabServiceStore = kaizenLabServiceStore;
    this.uiState = uiState;
  }

  public async getKaizenLabServiceList(organizationId: string) {
    const { kaizenLabServiceRepository, kaizenLabServiceStore, uiState } = this;
    try {
      const kaizenLabServiceList = await kaizenLabServiceRepository.getKaizenLabServiceOfOrganizatoin(organizationId);
      kaizenLabServiceStore.set(organizationId, kaizenLabServiceList);
      const roundMonitorInfo = kaizenLabServiceStore.getRoundMonitorInfo(organizationId);
      if (!roundMonitorInfo.permissions.find(permission => permission === 'read')) {
        uiState.setError({
          title: 'この組織のレポートを見るための権限がありません。',
          message: '詳しくは組織の管理者へお問い合わせください。',
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/application/usecase/KaizenLabServiceUsecase.ts